<template>
    <van-image
        width="15rem"
        height="15rem"
        fit="contain"
        src="/static/wait4complete.png"
        />
</template>
<script>
import { Image } from 'vant';

export default {
    name: 'StayTuned',
    data() {
    },
    mounted() {
        console.log("Wait for complete...");
    }
}
</script>


// WEBPACK FOOTER //
// src/components/StayTuned.vue